import React from 'react';

import styled from '@emotion/styled';

import { IconProps } from '../../IconsProps';

const StyledHistory = styled.svg<IconProps>`
  & .cls-1,
  .cls-2,
  .cls-3 {
    fill: none;
  }

  & .cls-1,
  .cls-2 {
    stroke: var(--chatbot-color-primary, #404040);
  }

  & .cls-2 {
    stroke-width: 1.5px;
  }
`;

const HistoryIcon: React.FC<IconProps> = props => {
  let activeClass = props.active ? 'active' : '';
  const isTouch = !!('ontouchstart' in window) || window.navigator.maxTouchPoints > 0;
  activeClass = `${activeClass} ${!isTouch ? 'hover' : ''}`;
  return (
    <StyledHistory
      id='History-Icon'
      xmlns='http://www.w3.org/2000/svg'
      width='32'
      height='32'
      viewBox='0 0 32 32'
      className={activeClass}
    >
      <g id='Chat_History' data-name='Chat History' transform='translate(-104 -8)'>
        <g id='Group_17509' data-name='Group 17509' transform='translate(-2124.764 -4229.544)'>
          <path
            id='df3f6432915484f53a7e72c168640c9f'
            className='cls-1'
            d='M11.708,2a9.737,9.737,0,0,0-9.737,9.737,9.63,9.63,0,0,0,2.2,6.164L.885,21.474s1.666.017,10.823,0A9.737,9.737,0,1,0,11.708,2Z'
            transform='translate(2234.093 4241.904)'
          />
          <path
            id='Path_15968'
            data-name='Path 15968'
            className='cls-2'
            d='M2243,4247.812v5.3l3.319,3.318'
            transform='translate(2.257 1.265)'
          />
        </g>
        <rect
          id='Rectangle_7276'
          data-name='Rectangle 7276'
          className='cls-3'
          width='32'
          height='32'
          transform='translate(104 8)'
        />
      </g>
    </StyledHistory>
  );
};

export default HistoryIcon;
